<template>
  <div class="d-flex mb-3 justify-content-between">
    <fcc-button
      color="light"
      class="shadow-sm"
      v-if="left"
      @click="anterior"
      :disabled="leftDisabled"
    >
      <font-awesome-icon icon="chevron-left" /> Anterior</fcc-button
    >
    <div v-else></div>
    <fcc-button
      color="light"
      class="shadow-sm"
      v-if="right"
      @click="proximo"
      :disabled="rightDisabled"
      >Próximo <font-awesome-icon icon="chevron-right"
    /></fcc-button>
    <div v-else></div>
  </div>
</template>
<script>
export default {
  props: {
    left: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    leftDisabled: {
      type: Boolean,
      default: false
    },
    rightDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    anterior() {
      this.$emit('anterior')
    },
    proximo() {
      this.$emit('proximo')
    }
  }
}
</script>